var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"src-components-cajas-toolbar"},[_c('v-btn',{attrs:{"color":"secondary","dark":"","small":""},on:{"click":function($event){return _vm.db_update()}}},[_c('v-icon',[_vm._v("mdi-update")]),_vm._v(" Actualizar")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }